<template>
  <div id="arquivos-uteis-introducao" data-search-anchor>
    <div class="userful-files-intro-content">
      <h1 class="intro-userful-files-title">{{ usefulFilesTitle }}</h1>
      <div class="intro-userful-files-description">
        <p class="intro-userful-files-description-paragraph">{{ usefulFilesDescription }}</p>
        <p class="intro-userful-files-description-paragraph">{{ usefulFilesDescriptionParagraph1 }}</p>
        <p class="intro-userful-files-description-paragraph">{{ usefulFilesDescriptionParagraph2 }}</p>
        <p class="intro-userful-files-description-paragraph">{{ usefulFilesDescriptionParagraph3 }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import UsefulFilesPageMixin from '@/mixins/useful-files-page-mixin'
import { UsefulFilesPageStore } from '@/store/useful-files-page/useful-files-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class UserfulFilesIntroSection extends Mixins(UsefulFilesPageMixin) {
  usefulFilesPageStore: PageStoreContract = getModule(UsefulFilesPageStore, this.$store)

  get usefulFilesTitle(): string {
    return this.getElementTitle(4, 0)
  }

  get usefulFilesDescription(): string {
    return this.getElementText(4, 0)
  }

  get usefulFilesDescriptionParagraph1(): string {
    return this.getElementText(4, 1)
  }

  get usefulFilesDescriptionParagraph2(): string {
    return this.getElementText(4, 2)
  }

  get usefulFilesDescriptionParagraph3(): string {
    return this.getElementText(4, 3)
  }

  async getUsefulFilesPage(): Promise<void> {
    await this.usefulFilesPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.usefulFilesPageStore.isLoading) {
      await this.getUsefulFilesPage()
    }
  }
}
</script>

<style lang="scss">
.userful-files-intro-content {
  display: grid;
  grid-template-columns: 50% 50%;
  max-width: 1032px;
  width: 100%;
  margin-top: 60px;
  margin-bottom: 25px;
}

.intro-userful-files-title {
  font-size: 48px;
  font-weight: 400;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  margin: 0;
}

.intro-userful-files-description {
  width: 478px;
}

.intro-userful-files-description-paragraph {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  padding-left: 3rem;
}
</style>
